<template>
	<div>
		<div id="map" :style="styles"></div>
	</div>
</template>

<script>
import markerImageSrc from '@/assets/images/common/map-marker.png';

const APP_KEY = '36fc57c47a61f2ccdac342dc44a60a45';
// 지점 마커 (웹 지점찾기와 같은 H 마커). 원본 64x96 이미지를 32x48 로 표시한다.
const MARKER_SIZE = [32, 48];

export default {
	name: 'KakaoMap',
	props: {
		width: {
			type: String,
			default: '100%',
		},
		height: {
			type: String,
			default: '200px',
		},
		coord: {
			type: Array,
			default: () => [],
			required: false,
		},
		address: {
			type: String,
			default: '',
			required: false,
		},
		isMarker: {
			type: Boolean,
			required: false,
		},
	},
	data() {
		return {
			map: null,
			markers: [],
		};
	},
	computed: {
		styles() {
			return `width: ${this.width};height: ${this.height};`;
		},
	},
	methods: {
		initMap(coords) {
			const container = document.getElementById('map');
			const centerCoords = coords || this.coord;
			const options = {
				center: new kakao.maps.LatLng(centerCoords[0], centerCoords[1]),
				level: 3, // 웹 지점찾기와 같은 확대 수준
			};
			this.map = new kakao.maps.Map(container, options);

			if (this.isMarker) {
				this.displayMarker([centerCoords]);
			}
		},
		searchAddressToCoordinate() {
			if (!this.address) {
				console.warn('KakaoMap: No address provided');
				return;
			}

			const geocoder = new kakao.maps.services.Geocoder();

			geocoder.addressSearch(this.address, (result, status) => {
				if (status === kakao.maps.services.Status.OK) {
					const coords = [parseFloat(result[0].y), parseFloat(result[0].x)];
					this.initMap(coords);
				} else if (this.coord && this.coord.length === 2) {
					// 주소로 못 찾으면(해외 지점 등) 저장된 좌표로 대신 표시
					this.initMap();
				} else {
					console.error(
						'KakaoMap: Address search failed',
						this.address,
						status,
					);
				}
			});
		},
		displayMarker(markerPositions) {
			if (this.markers.length > 0) {
				this.markers.forEach(marker => marker.setMap(null));
			}

			const positions = markerPositions.map(
				position => new kakao.maps.LatLng(...position),
			);

			if (positions.length > 0) {
				const image = new kakao.maps.MarkerImage(
					markerImageSrc,
					new kakao.maps.Size(...MARKER_SIZE),
				);

				this.markers = positions.map(
					position =>
						new kakao.maps.Marker({
							map: this.map,
							position,
							image,
						}),
				);

				// 마커가 하나면 확대 수준(level)은 유지하고 가운데로만 옮긴다
				if (positions.length === 1) {
					this.map.setCenter(positions[0]);
					return;
				}

				const bounds = positions.reduce(
					(bounds, latlng) => bounds.extend(latlng),
					new kakao.maps.LatLngBounds(),
				);

				this.map.setBounds(bounds);
			}
		},
		initializeMap() {
			// 주소가 있으면 주소로 검색
			if (this.address) {
				this.searchAddressToCoordinate();
			}
			// 좌표가 있으면 좌표로 초기화
			else if (this.coord && this.coord.length === 2) {
				this.initMap();
			} else {
				console.warn('KakaoMap: No address or coordinates provided');
			}
		},
	},
	mounted() {
		if (window.kakao && window.kakao.maps) {
			this.initializeMap();
		} else {
			const script = document.createElement('script');
			/* global kakao */
			script.onload = () => kakao.maps.load(this.initializeMap);
			script.src = `https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${APP_KEY}&libraries=services`;
			document.head.appendChild(script);
		}
	},
};
</script>
